module.exports = __webpack_public_path__ + "assets/img/69only_519_3.870761a7.jpg";